// src/components/Fields/DatePickerFieldPreview.jsx
import React from 'react';
import { Typography, Box } from '@mui/material';
import DateRangeIcon from '@mui/icons-material/DateRange';
import DraggablePreviewWrapper from './DraggablePreviewWrapper';  // Ensure the path is correct
import { useFormLayout } from '../../contexts/FormLayoutContext'; // Adjust path as necessary

const DatePickerFieldPreview = ({ id, index }) => {
    const { showDropZones, setShowDropZones } = useFormLayout();  // Use context to manage showDropZones

    // Render component with setShowDropZones passed to DraggablePreviewWrapper
    return (
        <DraggablePreviewWrapper
            id={id}
            type="date-picker"
            index={index}
            isNew={true}
            showDropZones={showDropZones} // Pass down showDropZones state
            setShowDropZones={setShowDropZones} // Pass down setShowDropZones function
        >
            <Box display="flex" alignItems="center">
                <DateRangeIcon sx={{ fontSize: '0.95rem', marginRight: '8px', color: '#455A64' }} />
                <Typography variant="body2" sx={{ flexGrow: 1, fontSize: '0.85rem', color: '#455A64' }}>
                    Date Picker
                </Typography>
            </Box>
        </DraggablePreviewWrapper>
    );
};

export default DatePickerFieldPreview;
